import React from 'react';
import {
  People, School, TrendingUp, Gavel, Balance, PersonRemove,
  HealthAndSafety, AttachMoney, VerifiedUser, AccountTree,
  PersonAdd, Event, Assessment, GroupWork, Security,
  Dashboard, Assignment, Folder, List, Extension, Business, Layers,
  ExitToApp, Verified, Equalizer, Warning,
} from '@mui/icons-material';

export const DOMAIN_ICONS: Record<string, React.ReactNode> = {
  'hr': <People />,
  'hr.onboarding': <PersonAdd />,
  'hr.skills-development': <School />,
  'hr.employment-equity': <Balance />,
  'hr.industrial-relations': <Gavel />,
  'hr.offboarding': <PersonRemove />,
  'hr.ohs': <HealthAndSafety />,
  'hr.structure': <AccountTree />,
  'hr.tes-labour-broker': <GroupWork />,
  'compliance': <Security />,
  'ledger': <AttachMoney />,
  'tutoring': <School />,
  'domain-engine': <Layers />,
};

export const RESOURCE_ICONS: Record<string, React.ReactNode> = {
  'employees': <People />,
  'onboarding-processes': <PersonAdd />,
  'employment-contracts': <Assignment />,
  'statutory-documents': <VerifiedUser />,
  'training-records': <School />,
  'training-providers': <School />,
  'courses': <School />,
  'contracts': <Assignment />,
  'ee-profiles': <Balance />,
  'disciplinary-cases': <Gavel />,
  'pips': <TrendingUp />,
  'terminations': <PersonRemove />,
  'workplace-injuries': <HealthAndSafety />,
  'ohs-certifications': <HealthAndSafety />,
  'ohs-representatives': <HealthAndSafety />,
  'departments': <AccountTree />,
  'role-templates': <Assignment />,
  'audit-logs': <VerifiedUser />,
  'compliance-calendar': <Event />,
  'dsar-requests': <VerifiedUser />,
  'invoices': <Assignment />,
  'receipts': <Assignment />,
  'accounts': <AttachMoney />,
  'journal-entries': <Assignment />,
  'tutors': <People />,
  'clients': <People />,
  'students': <People />,
  'qualifications': <School />,
  'services': <Assignment />,
  'service-authorisations': <Assignment />,
  'tutoring-agreements': <Assignment />,
  'tutoring-schedules': <Event />,
  'tutoring-sessions': <Event />,
  'attendance': <Assessment />,
  'tes-assignments': <GroupWork />,
  'tes-vendors': <GroupWork />,
  'deeming-alerts': <GroupWork />,
  'liability-records': <GroupWork />,
  'domains': <Layers />,
  'entitlements': <Security />,

  // Wizard icons
  'wizard/onboarding': <PersonAdd />,
  'wizard/disciplinary': <Gavel />,
  'wizard/pip': <TrendingUp />,
  'wizard/offboarding': <ExitToApp />,
  'wizard/training': <School />,
  'wizard/wsp-atr': <Assessment />,
  'wizard/injury': <HealthAndSafety />,
  'wizard/certification': <Verified />,
  'wizard/ohs-event': <Event />,
  'wizard/ee-report': <Equalizer />,
  'wizard/contract-alert': <Warning />,

  // Workflow Manager icons
  'hr/onboarding': <AccountTree />,
  'hr/industrial-relations': <AccountTree />,
  'hr/offboarding': <AccountTree />,
  'hr/ohs': <AccountTree />,
  'hr/skills-development': <AccountTree />,
  'hr/employment-equity': <AccountTree />,
  'hr/compliance': <AccountTree />,

  // Tutoring wizard icons
  'wizard/tutor': <People />,
  'wizard/student': <People />,
  'wizard/client': <People />,
  'wizard/service-authorisation': <Assignment />,
  'wizard/tutoring-session': <Event />,
  'wizard/tutoring-agreement': <Assignment />,
  'wizard/tutoring-schedule': <Event />,
  'wizard/attendance': <Assessment />,

  // Tutoring workflow manager icons
  'hr/tutoring/session/workflows': <AccountTree />,
  'hr/tutoring/agreement/workflows': <AccountTree />,
  'hr/tutoring/schedule/workflows': <AccountTree />,

  // Dashboard icons
  'wsp-atr-dashboard': <Assessment />,
  'onboarding-dashboard': <Dashboard />,
  'ohs-calendar': <Event />,
};

export const getDomainIcon = (domainId: string): React.ReactNode => {
  return DOMAIN_ICONS[domainId] || <Extension />;
};

export const getResourceIcon = (resourceName: string): React.ReactNode => {
  return RESOURCE_ICONS[resourceName] || <Assignment />;
};
